import gql from 'graphql-tag';

const EXPORT_CARD_TRANSACTION_EVENTS = gql`
  mutation exportCardTransactions($params: ExportCardTransactionsInput!) {
    exportCardTransactions(params: $params) {
      uuid
    }
  }
`;

export default EXPORT_CARD_TRANSACTION_EVENTS;
